import {
  Box,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material';
import React from 'react';

const termsData = [
  {
    title: 'Acceptance of Terms',
    description:
      'By accessing or using our services, you agree to be bound by these Terms. If you do not agree, please do not use our services.',
  },
  {
    title: 'Changes to Terms',
    description:
      'We may update these Terms from time to time. The updated Terms will be posted on our website, and the date of the last update will be indicated. Your continued use of our services after changes are made constitutes acceptance of the new Terms.',
  },
  {
    title: 'User Accounts',
    description:
      'To access certain features, you may need to create an account. You agree to provide accurate and complete information and to keep your account information updated. You are responsible for maintaining the confidentiality of your account and password.',
  },
  {
    title: 'Use of Services',
    description:
      'You agree to use our services only for lawful purposes and in accordance with these Terms. You shall not use our services to:',
    bulletPoints: [
      'Engage in any activity that violates any applicable law or regulation.',
      'Upload or distribute any harmful, offensive, or illegal content.',
      'Attempt to interfere with the operation of our services.',
    ],
  },
  {
    title: 'Intellectual Property',
    description:
      'All content, trademarks, and other intellectual property on our website are the property of Aspire or its licensors. You may not use, reproduce, or distribute any content without our written permission.',
  },
  {
    title: 'Disclaimer of Warranties',
    description:
      "Our services are provided 'as is' without any warranties of any kind, either express or implied. We do not warrant that our services will be uninterrupted or error-free.",
  },
  {
    title: 'Limitation of Liability',
    description:
      'To the maximum extent permitted by law, Aspire shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or in connection with your use of our services.',
  },
  {
    title: 'Third-Party Links',
    description:
      'Our website may contain links to third-party websites or services. We are not responsible for the content or practices of these third-party websites.',
  },
  {
    title: 'Privacy Policy',
    description:
      'Our Privacy Policy explains how we collect, use, and protect your information. By using our services, you consent to our collection and use of your information as described in the Privacy Policy.',
  },
  {
    title: 'Termination',
    description:
      'We reserve the right to terminate or suspend your access to our services at any time, without notice, for any reason, including a breach of these Terms.',
  },
];

const TermsOfService = () => (
  <Box sx={{ padding: '20px', height: 'calc(100vh - 48px)', overflow: 'auto' }}>
    <Typography variant="h6" color="#2B1E59">
      Terms Of Service
    </Typography>
    <Box paddingTop="20px">
      <Typography variant="h4" color="#2B1E59">
        Last Updated: August 1, 2024
      </Typography>
      <Typography variant="body1">
        Welcome to Aspire! These Terms of Service &quot;Terms&quot; govern your
        use of our website and services.By accessing or using Aspire, you agree
        to be bound by these Terms.
      </Typography>
    </Box>
    <Box padding="20px 0px">
      <Divider />
    </Box>

    <Grid container spacing={3}>
      {termsData.map((item, index) => (
        <Grid key={`${index + 1}`} item xs={12}>
          <Grid container spacing={2} alignItems="flex-start">
            {/* Title Column */}
            <Grid item xs={3}>
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 'bold',
                  whiteSpace: 'nowrap',
                  color: '#2B1E59',
                }}
              >
                {item.title}:
              </Typography>
            </Grid>
            {/* Description Column */}
            <Grid item xs={9}>
              <Typography variant="body1">{item.description}</Typography>
              {item.bulletPoints && (
                <List
                  sx={{
                    marginTop: 1,
                    display: 'list-item',
                  }}
                >
                  {item.bulletPoints.map((bullet, index) => (
                    <ListItem
                      key={`${index + 1}`}
                      sx={{
                        display: 'list-item',
                        padding: 0,
                        listStyleType: 'disc',
                      }}
                    >
                      <ListItemText primary={bullet} />
                    </ListItem>
                  ))}
                </List>
              )}
            </Grid>
          </Grid>

          {/* Bullet Points */}
        </Grid>
      ))}
    </Grid>
  </Box>
);

export default TermsOfService;
